import { createSharedState } from 'Shared/use-shared-state';

export const hideSubBoxSlice = createSharedState('hideSubBox', App.isSubscribed);
export const useHideSubBox = hideSubBoxSlice.hook;
